import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCTA } from './components/FloatingCTA';
import { PurchasePopup } from './components/PurchasePopup';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { BeforeAfter } from './components/sections/BeforeAfter';
import { Pathway } from './components/sections/Pathway';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { CaseScenario } from './components/sections/CaseScenario';
import { NotTheory } from './components/sections/NotTheory';
import { Audience } from './components/sections/Audience';
import { Creator } from './components/sections/Creator';
import { Testimonials } from './components/sections/Testimonials';
import { Offer } from './components/sections/Offer';
import { Guarantee } from './components/sections/Guarantee';
import { FAQ } from './components/sections/FAQ';
import { FinalCTA } from './components/sections/FinalCTA';
export function App() {
  return <div className="min-h-screen w-full overflow-x-hidden bg-white font-sans text-navy" data-id="element-0" data-mp="3mlavl1vse5rc">
      <MetaPixel data-id="element-1" data-mp="3rc9e8848zfxr" />
      <Hero data-id="element-2" data-mp="3rbrakqf99zft" />
      <main data-id="element-3" data-mp="3rbzq6q2rjiup">
        <Problem data-id="element-4" data-mp="3rdkie91luppe" />
        <BeforeAfter data-id="element-5" data-mp="3rd1a7k1rbfok" />
        <Pathway data-id="element-6" data-mp="3relvsk63foaa" />
        <Volumes data-id="element-7" data-mp="5os92t1uy7l" />
        <Bonuses data-id="element-8" data-mp="680frswe88f" />
        <CaseScenario data-id="element-9" data-mp="4n725ibkvc5" />
        <NotTheory data-id="element-10" data-mp="82kz509bybz" />
        <Audience data-id="element-11" data-mp="2zl3bdjx5744s" />
        <Creator data-id="element-12" data-mp="2zllduyaeeel5" />
        <Testimonials data-id="element-13" data-mp="2zm4wyibsb90r" />
        <Offer data-id="element-14" data-mp="2zmwif0bo3qdb" />
        <Guarantee data-id="element-15" data-mp="2zn66ujh2dpgw" />
        <FAQ data-id="element-16" data-mp="33mf2xuzktzfm" />
        <FinalCTA data-id="element-17" data-mp="33m5c656pjo8v" />
      </main>
      <FloatingCTA data-id="element-18" data-mp="33ngiabnml835" />
      <PurchasePopup data-id="element-19" data-mp="33orhrza1ftog" />
    </div>;
}